import { render, staticRenderFns } from "./huotiDetail.vue?vue&type=template&id=3a7bf45c&scoped=true&"
import script from "./huotiDetail.vue?vue&type=script&lang=js&"
export * from "./huotiDetail.vue?vue&type=script&lang=js&"
import style0 from "./huotiDetail.vue?vue&type=style&index=0&id=3a7bf45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7bf45c",
  null
  
)

export default component.exports